import { observer } from "mobx-react-lite";
import React from "react";

import { QuestionnaireFor } from "@Core/constants/ENUMS";

import { DigitalQuestionnaire } from "@PNI/components/Containers";

import { Introduction } from "./internal/components/Introduction/Introduction";

const SupervisorQuestionnare = () => {
  return (
    <DigitalQuestionnaire type={QuestionnaireFor.SUPERVISOR}>
      {({ onComplete }) => <Introduction type={QuestionnaireFor.SUPERVISOR} onComplete={onComplete} />}
    </DigitalQuestionnaire>
  );
};

export default observer(SupervisorQuestionnare);
